import { createFeature, createReducer, on } from '@ngrx/store'
import { CouponState } from './coupon.state'
import { loadCouponsSuccess } from './coupon.actions'

export const initialState: CouponState = {
  coupons: [],

  activeCount: 0,
  inactiveCount: 0,
  expiredCount: 0,
  analytics: null,

  loading: false,

  error: null,

  totalCount: 0
}

export const couponReducer = createReducer(
  initialState,
  on(loadCouponsSuccess, (state, action) => ({
    ...state,
    coupons: action.coupons,
    totalCount: action.totalCount,
    activeCount: action.activeCount,
    inactiveCount: action.inactiveCount,
    expiredCount: action.expiredCount,
    loading: false,
    error: null
  }))
)
export const couponFeature = createFeature({
  name: 'coupon',
  reducer: couponReducer
})
